import React from "react";
import {clone} from "lodash";
import defaultImage from './default_plate.jpeg';

const ItemImage = (props) => {
  let newProps = clone(props)
  newProps.src ||= defaultImage
  newProps.width ||= 150
  newProps.alt ||= 'User Avatar'

  return <img {...newProps} alt={newProps.alt}/>
}

export default ItemImage;